import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {getAutocompleteValue} from 'src/infrastructure/helper/autocomplete-helper';
import {SearchTramsInvoiceResponse} from '../model/search-trams-invoice-response';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TramsInvoiceGridService implements GridGetService<SearchTramsInvoiceResponse> {
  private readonly baseUrl = 'dbov2/invoice';
  private readonly http = inject(HttpClient);

  public getExportFilters(filters: any): Record<string, any> {
    const exportFilters: Record<string, any> = { ...filters };
    if (filters['issueStartDate']) {
      exportFilters['issueStartDate'] = moment(filters['issueStartDate']).format('YYYY-MM-DD');
    }
    if (filters['issueEndDate']) {
      exportFilters['issueEndDate'] = moment(filters['issueEndDate']).format('YYYY-MM-DD');
    }
    if (filters['createdStartDate']) {
      exportFilters['createdStartDate'] = moment(filters['createdStartDate']).format('YYYY-MM-DD');
    }
    if (filters['createdEndDate']) {
      exportFilters['createdEndDate'] = moment(filters['createdEndDate']).format('YYYY-MM-DD');
    }
    return exportFilters;
  }

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchTramsInvoiceResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      TramsInvoiceNo: getAutocompleteValue(filters?.['tramsInvoiceNo']),
      InvoiceRecordLocator: getAutocompleteValue(filters?.['invoiceRecordLocator']),
      issueStartDate: filters?.['issueStartDate'] ? moment(filters?.['issueStartDate']).format('YYYY-MM-DD') : '',
      issueEndDate: filters?.['issueEndDate'] ? moment(filters?.['issueEndDate']).format('YYYY-MM-DD') : '',
      createdStartDate: filters?.['createdStartDate'] ? moment(filters?.['createdStartDate']).format('YYYY-MM-DD') : '',
      createdEndDate: filters?.['createdEndDate'] ? moment(filters?.['createdEndDate']).format('YYYY-MM-DD') : '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<SearchTramsInvoiceResponse>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }
}
